export default "__VITE_ASSET__cLbhEXlF__"